"use client"

import Navigation from "../../Navigation"
import { useLanguage } from "../../LanguageContext"

interface HeaderProps {
  mobileMenuOpen: boolean
  toggleMobileMenu: () => void
  appConfig?: any
  currentPage?: "home" | "about" | "none"
}

export default function Header({ mobileMenuOpen, toggleMobileMenu, appConfig, currentPage = "none" }: HeaderProps) {
  const { language } = useLanguage()

  // Simple translation function
  const t = (path: string, defaultText: string) => {
    // If appConfig isn't loaded yet, return the default text
    if (!appConfig) return defaultText

    // Split the path by dots to navigate nested objects
    const keys = path.split(".")
    let value = appConfig

    // Navigate through the object
    for (const key of keys) {
      if (!value || !value[key]) return defaultText
      value = value[key]
    }

    // Return the localized text if it's an object with language keys
    if (value && typeof value === "object" && value[language.code]) {
      return value[language.code]
    }

    // Return the value if it's a string or the default text
    return typeof value === "string" ? value : value.en || defaultText
  }

  // Handle navigation - this is now simplified since we're using direct links
  const handleNavigation = (page: "home" | "about") => {
    // This function is kept for compatibility but no longer needs to do anything
    console.log(`Navigation to ${page} requested`)
  }

  // Use the Navigation component
  return (
    <Navigation
      appConfig={
        appConfig || {
          branding: {
            logoLight: "/images/blinkli-light.png",
            logoAlt: "Blinkli",
          },
        }
      }
      currentPage={currentPage}
      onNavigate={handleNavigation}
      t={t}
    />
  )
}
